/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Theme_SelectionInputs */



/**
* | output |
* | --- |
* | "Theme Selection" |
*
* @param {Theme_SelectionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const theme_selection = /** @type {((inputs?: Theme_SelectionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Theme_SelectionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sélection du thème")
	if (locale === "de") return /** @type {LocalizedString} */ ("Themenauswahl")
	if (locale === "it") return /** @type {LocalizedString} */ ("Selezione del tema")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выбор темы")
	if (locale === "es") return /** @type {LocalizedString} */ ("Selección de temas")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("主题选择")
	if (locale === "ja") return /** @type {LocalizedString} */ ("テーマの選択")
	if (locale === "hi") return /** @type {LocalizedString} */ ("विषय चयन")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Seleção do tema")
	return /** @type {LocalizedString} */ ("Theme Selection")
});